export function ChevronRightFillIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M8.94157 6.82237C9.51557 6.42469 9.51557 5.57606 8.94157 5.17838L4.19751 1.8916C3.53431 1.43212 2.62801 1.90677 2.62801 2.71359L2.62801 9.28715C2.62801 10.094 3.53431 10.5686 4.19751 10.1091L8.94157 6.82237Z" fill="#98A2B3" />
    </svg>
  );
}

ChevronRightFillIcon.displayName = 'ChevronRightFillIcon';
